// No url(#id) masks/gradients: the first copy in the DOM owns the id, and when it is hidden
// (display: none — Receipt program cards at ≤640px) every other copy loses that paint.
const VerifiFromAlerts = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="4" fill="#1C33C3" />
    <path
      d="M12.1353 5.55566L9.82531 11.5234L8.86309 6.44455C8.7342 5.87344 8.28531 5.55566 7.83642 5.55566H4.50976L4.44531 5.81011C5.21531 6.00011 5.7942 6.19011 6.30753 6.44455C6.46754 6.52455 6.60087 6.66678 6.68198 7.27011L8.34976 14.4446H10.7231L14.4453 5.55566H12.1353Z"
      fill="white"
    />
  </svg>
)

export default VerifiFromAlerts
